import en from './locales/en';
import hi from './locales/hi';
import mr from './locales/mr';

const translations = {
  en,
  hi,
  mr
};

export default translations;